import { ItemData } from '../data/ItemData'; // Adjust path if ItemData is elsewhere

export const getItemImageSrc = (itemKeyOrPathSuffix, subDirectory = '') => {
  const prefix = '/img/'; // Assuming your images are in public/img/

  if (!itemKeyOrPathSuffix) {
    return `${prefix}placeholder.png`;
  }

  // Handle cases where itemKeyOrPathSuffix might be an object (like furnace on/off states)
  // For now, we'll assume it's a string key or direct path.
  // You can expand this later based on your old ui.js logic if needed for things like furnace state.

  if (typeof itemKeyOrPathSuffix === 'string') {
    const baseItem = ItemData[itemKeyOrPathSuffix];
    if (baseItem && baseItem.img) {
      // baseItem.img could be 'wearables/woodenPickaxe.png'
      // Or it could be an object for different states { on: 'path.png', off: 'path.png' }
      if (typeof baseItem.img === 'object' && baseItem.img.default) { // Example if you add a 'default' state
          return `${prefix}${baseItem.img.default}`;
      } else if (typeof baseItem.img === 'string') {
          return `${prefix}${baseItem.img}`;
      }
      // If baseItem.img is an object but no clear default, or complex logic needed, handle here
    }
    // Fallback if itemKeyOrPathSuffix is a direct path fragment
    if (itemKeyOrPathSuffix.includes('/')) {
        return `${prefix}${itemKeyOrPathSuffix}`;
    }
    // Fallback for simple names if not found in ItemData (less ideal)
    // return `${prefix}${subDirectory}${String(itemKeyOrPathSuffix).toLowerCase().replace(/\s+/g, '')}.png`;
  }

  return `${prefix}placeholder.png`; // Default fallback
};